// extracted by mini-css-extract-plugin
module.exports = {"conceptAction":"style-module__conceptAction___1iqAc","conceptName":"style-module__conceptName___L2i5b","conceptPercentCorrect":"style-module__conceptPercentCorrect___11HNK"};